export function searchPage() {

    const searchPageInput = document.querySelector('.js-searchPageInput');
    const searchPagePrompt = document.querySelector('.js-searchPagePrompt');
    const searchPageShowMore = document.querySelector('.js-searchPageShowMore');
    const searchPageResult = document.querySelector('.js-searchPageResult');
    const formSearch = document.querySelector('.js-formSearch');
    let page = 1;

    if (!searchPageInput) {
        return false;
    }

    /**
     * Клик по кнопке "Показать ещё"
     */
    searchPageShowMore.addEventListener('click', function(e) {
        // следующая страница
        page++;

        const params = Array.from(formSearch.querySelectorAll('input[name]')).reduce(function(acc, $input) {
            acc.push($input.getAttribute('name') + '=' + encodeURIComponent($input.value));
            return acc;
        }, []);

        params.push('page=' + page);

        const url = formSearch.getAttribute('action') + '?' + params.join('&');

        fetch(url, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        })
        .then(response => response.json())
        .then(r => {
            if (r.status == 'ok') {
                searchPageResult.insertAdjacentHTML('beforeend', r.data.search_results_render);
                adaptive(cutText);
            } else if (r.status == 'error') {

            }

            // прячем кнопку если результатов больше нет
            searchPageShowMore.classList.toggle('is-hidden', !r.data.search_more);
        });
    });

    searchPageInput.addEventListener('input', function (e) {
        if (searchPageInput.value.length == 0) {
            searchPagePrompt.classList.remove('is-active');
            return;
        }

        fetch('/search?query=' + encodeURIComponent(searchPageInput.value), {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        })
        .then(response => response.json())
        .then(r => {
            // удаляем старые варианты
            while (searchPagePrompt.lastElementChild) {
                searchPagePrompt.removeChild(searchPagePrompt.lastElementChild);
            }

            // результаты поиска
            if (r.data && r.data.search_results && r.data.search_results.length) {
                r.data.search_results.forEach(function(item) {
                    searchPagePrompt.insertAdjacentHTML('beforeend',
                        `<li class="search-page_prompt-item js-searchPagePromptItem">${item.title}</li>`
                    );
                });

                // Клик на подсказку
                const searchPagePromptItem = document.querySelectorAll('.js-searchPagePromptItem');

                searchPagePromptItem.forEach( function(item) {
                    item.addEventListener('mousedown', function() {
                        searchPageInput.value = item.textContent;

                        // отправка формы
                        formSearch.submit();
                    });
                });
            } else {
                searchPagePrompt.insertAdjacentHTML('beforeend',
                    `<li class="search-page_prompt-item search-page_prompt-item--alert">
                        Ничего не найдено
                    </li>`
                );
            }

            // показываем результаты
            searchPagePrompt.classList.add('is-active');
        });
    });

    searchPageInput.addEventListener('focus', function () {
        searchPagePrompt.classList.toggle('is-active', searchPagePrompt.childElementCount);
    });

    searchPageInput.addEventListener('blur', function () {
        searchPagePrompt.classList.remove('is-active');
    });

    // Обрезать текст

    function cutText() {
        const searchPageResultText = document.querySelectorAll('.js-searchPageResultText');

        let textLength = window.innerWidth > 767 ? 145 : 67;

        searchPageResultText.forEach( function(item) {

            if (item.textContent.length <= textLength) {
                return false;
            }

            let currentText = item.textContent,
                textArr = currentText.split('');

            textArr.forEach( function(elem, index) {
                if (index >= textLength) {
                    textArr.splice(textLength, index);
                }
            });

            let finalText = textArr.join('') + '...';

            item.textContent = finalText;
        });
    }

    function adaptive(script) {
        script();

        ['resize', 'orientationChange'].forEach( function(item) {
            window.addEventListener(item, script);
        });
    }

    adaptive(cutText);
}
